import { render, staticRenderFns } from "./EntSwitch.vue?vue&type=template&id=3ab9c252"
import script from "./EntSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./EntSwitch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports